import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import DemandesScreen from './DemandesScreen';
import FacturationScreen from './FacturationScreen';
import PaysCrud from './PaysCrud';
import VisasCrud from './VisasCrud';
import UtilisateursScreen from './UtilisateursScreen';
import TableauDeBord from './TableauDeBord';
import MailsScreen from './MailsScreen';
import AlertesScreen from './AlertesScreen';
import FormulairesScreen from './FormulairesScreen';
import PiecesJointesScreen from './PiecesJointesScreen';
import SocietesScreen from './SocietesScreen';
import ExtensionChromeScreen from './ExtensionChromeScreen';
import LoginLegrand from './legrand/LoginLegrand';
import DashboardLegrand from './legrand/DashboardLegrand';
import DemandesScreenLegrand from './legrand/DemandesScreenLegrand';
import AdressesScreenLegrand from './legrand/AdressesScreenLegrand';
import EmailsScreenLegrand from './legrand/EmailsScreenLegrand';

function AppRouter() {
  const [societe, setSociete] = useState<string | null>(null);

  useEffect(() => {
    // Priorité 1: Variable d'environnement (définie au démarrage)
    const companyFromEnv = process.env.REACT_APP_COMPANY;

    // Priorité 2: Paramètre URL (pour compatibilité)
    const urlParams = new URLSearchParams(window.location.search);
    const societeParam = urlParams.get('societe');

    // Si la variable d'environnement est définie, l'utiliser
    if (companyFromEnv) {
      setSociete(companyFromEnv.toLowerCase());
      localStorage.setItem('societe', companyFromEnv.toLowerCase());
    }
    // Sinon, utiliser le paramètre URL si présent
    else if (societeParam && societeParam.toLowerCase() === 'legrand') {
      setSociete('legrand');
      localStorage.setItem('societe', 'legrand');
    }
    // Sinon, mode admin standard
    else {
      localStorage.removeItem('societe');
      setSociete(null);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {societe === 'legrand' ? (
          <>
            {/* Routes pour Legrand */}
            <Route path="/" element={<LoginLegrand />} />
            <Route path="/login" element={<LoginLegrand />} />
            <Route path="/legrand/dashboard" element={<DashboardLegrand />} />
            <Route path="/legrand/demandes" element={<DemandesScreenLegrand />} />
            <Route path="/legrand/demandes/:id" element={<DemandesScreenLegrand />} />
            <Route path="/legrand/demandes/:id/edit" element={<DemandesScreenLegrand />} />
            <Route path="/legrand/adresses" element={<AdressesScreenLegrand />} />
            <Route path="/legrand/emails" element={<EmailsScreenLegrand />} />
            <Route path="/legrand/*" element={<DashboardLegrand />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            {/* Routes par défaut */}
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/tdb" element={<TableauDeBord />} />
            <Route path="/demandes" element={<DemandesScreen />} />
            <Route path="/facturation" element={<FacturationScreen />} />
            <Route path="/pays" element={<PaysCrud />} />
            <Route path="/visas" element={<VisasCrud />} />
            <Route path="/utilisateurs" element={<UtilisateursScreen />} />
            <Route path="/societes" element={<SocietesScreen />} />
            <Route path="/mails" element={<MailsScreen />} />
            <Route path="/alertes" element={<AlertesScreen />} />
            <Route path="/formulaires" element={<FormulairesScreen />} />
            <Route path="/pieces-jointes" element={<PiecesJointesScreen />} />
            <Route path="/extension-chrome" element={<ExtensionChromeScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;